import { makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";

const styles = makeStyles(({ spacing, palette }) => ({
  root: {
    width: "100%",
    padding: spacing(3),
    borderRadius: spacing(1),
    border: "1px solid rgba(0, 0, 0, 0.15)",
    backgroundColor: palette.otherElementsBackground.main,
  },
  input: {
    "& input": {
      color: palette.contrastText.main,
    },
    "& fieldset": {
      borderColor: palette.secondaryContrast.main,
    },
    "& label": {
      color: palette.contrastText.main,
    },
    "& label.Mui-disabled": {
      color: palette.inputLabelDisabled.main,
    },
    "& div": {
      "&.Mui-error fieldset": {
        borderColor: `${palette.error.main} !important`,
      },
      "&:hover fieldset": {
        borderColor: `${palette.contrastText.main} !important`,
      },
      "&.Mui-focused fieldset": {
        borderColor: `${palette.primary.main} !important`,
      },
    },
  },
  item: {
    padding: spacing(1),
    borderRadius: spacing(1),
  },
  itemError: {
    backgroundColor: palette.alertError.main,
  },
  header: {
    borderRadius: spacing(3),
    border: `1px solid ${palette.primary.main}`,
    width: "fit-content",
    maxWidth: "100%",
    padding: spacing(0.5, 1.5),
  },
  icon: {
    paddingLeft: spacing(1),
  },
  discountItemTitle: {
    fontWeight: 500,
  },
  discountItemSupplier: {
    color: palette.secondaryTextDisabled.main,
  },
  removeBtn: {
    padding: spacing(0.25),
    flex: 0,
  },
  removeIcon: {
    width: 16,
    height: 16,
    color: palette.secondaryTextDisabled.main,
  },
  snackbar: {
    boxShadow: "rgba(0, 0, 0, 0.5)",
  },
  snackbarMessage: {
    color: grey[800],
    whiteSpace: "pre-line",
  },
  alertText: {
    color: palette.contrastText.main,
  },
}));

export default styles;
